import { CSSProperties, FC } from "react";
import { Table } from "antd";
import { clsx } from "clsx";
import { NegotiatedTerm } from "../../../../types/IntelligenceTypes";
import styles from "./MarketTrendsCommon.module.less";

const { Column } = Table;

interface NegotiatedTermsProps {
    data?: NegotiatedTerm[];
    style?: CSSProperties;
}

export const NegotiatedTerms: FC<NegotiatedTermsProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>Commonly negotiated terms</div>
            <Table dataSource={data} pagination={false} size="small">
                <Column title="Terms" dataIndex="term" width={334} />
                <Column title="Standard/Optional" dataIndex="type" width={334} />
                <Column title="Red Flags" dataIndex="flag" />
            </Table>
        </div>
    );
};
